const distance = require('natural/lib/natural/distance');
export default distance;